"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _react = _interopRequireWildcard(require("react"));
var _DeviceChartContainerModule = _interopRequireDefault(require("../../styles/components/DeviceLineChart/DeviceChartContainer.module.css"));
var _index = require("../index");
var _constants = require("../../utils/constants");
var _reactRedux = require("react-redux");
var _selectors = require("../../redux/selectors");
var _actions = require("../../redux/actions");
var _function = require("../../utils/function");
var _paulCorePackage = require("paul-core-package");
var _material = require("@mui/material");
var _ChartParams = require("../../features/provider/ChartParams");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const temperature = _constants.yAxisTypes.temperature;
const MultiChart = _ref => {
  var _activeSelectors$y1Ax3, _activeSelectors$y2Ax3;
  let {
    chartId = null,
    equipmentType,
    equipmentId,
    isPrediction
  } = _ref;
  const {
    inProgress,
    rangeType,
    dateType
  } = (0, _reactRedux.useSelector)((0, _selectors.selectChartParams)(chartId), (prev, next) => _paulCorePackage.functions.areEqual(prev, next));
  const {
    isDynamicHeight
  } = (0, _ChartParams.useChartParams)();
  const [y1Data, setY1Data] = (0, _react.useState)([]);
  const [y2Data, setY2Data] = (0, _react.useState)([]);
  const [yScale, setYScale] = (0, _react.useState)({});
  const dispatch = (0, _reactRedux.useDispatch)();
  const chartData = (0, _reactRedux.useSelector)(_selectors.selectChartData)[chartId] || null;
  const activeSelectors = (0, _reactRedux.useSelector)(_selectors.getActiveSelectors);
  const tV = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsValues);
  const getColor = (0, _react.useCallback)(displayId => {
    var _tV$Colours;
    if ((_tV$Colours = tV.Colours) !== null && _tV$Colours !== void 0 && (_tV$Colours = _tV$Colours[equipmentType]) !== null && _tV$Colours !== void 0 && _tV$Colours[displayId]) {
      return "#".concat(tV.Colours[equipmentType][displayId]);
    }
    return _constants.defaultLineColor;
  }, [tV, equipmentType]);
  const setInProgress = (0, _react.useCallback)(newInProgress => {
    dispatch((0, _actions.setChartParamsList)({
      chartId,
      params: {
        inProgress: newInProgress
      }
    }));
  }, [dispatch, chartId]);
  const getDataByYAxis = (0, _react.useCallback)(_ref2 => {
    let {
      displayNameIdByYAxis = [],
      y1Axis = false,
      y2Axis = false
    } = _ref2;
    const dataByType = (chartData[equipmentType] || {})[equipmentId] || {};
    return Object.values(dataByType).reduce((accList, devicePDIdObj) => [...accList, ...Object.keys(devicePDIdObj).reduce((acc, key) => {
      if (!displayNameIdByYAxis.includes(key)) return acc;
      if (devicePDIdObj[key].length !== 0) {
        // const title = ''
        const line = {
          id: key,
          color: getColor(key),
          //title: `${title}`,
          data: (0, _function.getChartData)({
            data: devicePDIdObj[key],
            rangeType: rangeType
          })
        };
        return [...acc, line];
      } else {
        return acc;
      }
    }, [])], []);
  }, [chartData, rangeType, chartId, getColor]);
  const allY1Data = (0, _react.useMemo)(() => {
    return y1Data.reduce((acc, item) => [...acc, ...(item.data || []).reduce((accD, dataItem) => [...accD, dataItem.y], [])], []);
  }, [y1Data]);
  const allY2Data = (0, _react.useMemo)(() => {
    return y2Data.reduce((acc, item) => [...acc, ...(item.data || []).reduce((accD, dataItem) => [...accD, dataItem.y], [])], []);
  }, [y2Data]);
  const setActive = (0, _react.useCallback)(d => {
    return dispatch((0, _actions.setActiveChartData)({
      chartId,
      data: {
        data: d.slice.points,
        rangeType
      }
    }));
  }, [dispatch, rangeType]);
  (0, _react.useEffect)(() => {
    var _activeSelectors$disp, _activeSelectors$disp2;
    if (!chartData) return;
    setY1Data(getDataByYAxis({
      displayNameIdByYAxis: (_activeSelectors$disp = activeSelectors.displayNameId) === null || _activeSelectors$disp === void 0 ? void 0 : _activeSelectors$disp.y1Axis,
      y1Axis: true
    }));
    setY2Data(getDataByYAxis({
      displayNameIdByYAxis: (_activeSelectors$disp2 = activeSelectors.displayNameId) === null || _activeSelectors$disp2 === void 0 ? void 0 : _activeSelectors$disp2.y2Axis,
      y2Axis: true
    }));
  }, [chartData, rangeType, chartId, activeSelectors]);

  /** @todo maybe that's wrong */
  (0, _react.useEffect)(() => {
    if (y1Data.length) {
      setInProgress(false);
    }
  }, [y1Data.length]);
  (0, _paulCorePackage.useDeepEffect)(() => {
    var _activeSelectors$y1Ax, _activeSelectors$y2Ax;
    const isTemperature = {
      y1: (activeSelectors === null || activeSelectors === void 0 || (_activeSelectors$y1Ax = activeSelectors.y1AxisSelect) === null || _activeSelectors$y1Ax === void 0 ? void 0 : _activeSelectors$y1Ax.type) === temperature,
      y2: (activeSelectors === null || activeSelectors === void 0 || (_activeSelectors$y2Ax = activeSelectors.y2AxisSelect) === null || _activeSelectors$y2Ax === void 0 ? void 0 : _activeSelectors$y2Ax.type) === temperature
    };
    setYScale({
      y1Scale: {
        type: "linear",
        stacked: false,
        reverse: false,
        min: (0, _ChartParams.getHeightByFlag)({
          isDynamicHeight,
          value: 0
        }),
        max: (0, _ChartParams.getHeightByFlag)({
          isDynamicHeight,
          value: isTemperature.y1 ? _constants.maxWaterTemperature : Math.max(...allY1Data)
        })
      },
      y2Scale: {
        type: "linear",
        stacked: false,
        reverse: false,
        min: (0, _ChartParams.getHeightByFlag)({
          isDynamicHeight,
          value: 0
        }),
        max: (0, _ChartParams.getHeightByFlag)({
          isDynamicHeight,
          value: isTemperature.y2 ? _constants.maxWaterTemperature : Math.max(...allY2Data)
        })
      }
    });
  }, [allY1Data, allY2Data, isDynamicHeight]);
  return (0, _react.useMemo)(() => {
    var _activeSelectors$y1Ax2, _activeSelectors$y2Ax2;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(_DeviceChartContainerModule.default.chart, " line-chart")
    }, /*#__PURE__*/_react.default.createElement(_index.Charts.DeviceChart, {
      data: inProgress ? [] : y1Data,
      rangeType: rangeType,
      dateType: dateType,
      setActive: setActive,
      isPrediction: isPrediction,
      inProgress: inProgress,
      setInProgress: setInProgress,
      yScale: yScale.y1Scale,
      unit: (_activeSelectors$y1Ax2 = activeSelectors.y1AxisSelect) === null || _activeSelectors$y1Ax2 === void 0 ? void 0 : _activeSelectors$y1Ax2.unit,
      withTitle: false,
      curve: _constants.curveTypes.linear
    }), y2Data.length !== 0 ? /*#__PURE__*/_react.default.createElement(_index.Charts.DeviceChart, {
      data: inProgress ? [] : y1Data.map(d => _objectSpread(_objectSpread({}, d), {}, {
        transparent: true
      })).concat(y2Data),
      rangeType: rangeType,
      dateType: dateType,
      setActive: setActive,
      isPrediction: isPrediction,
      inProgress: inProgress,
      setInProgress: setInProgress,
      yScale: yScale.y2Scale,
      y1Axis: false,
      y2Axis: true,
      enableGridY: false,
      unit: (_activeSelectors$y2Ax2 = activeSelectors.y2AxisSelect) === null || _activeSelectors$y2Ax2 === void 0 ? void 0 : _activeSelectors$y2Ax2.unit,
      withTitle: false,
      withAxesBottom: false,
      curve: _constants.curveTypes.linear
    }) : null, inProgress ? /*#__PURE__*/_react.default.createElement("div", {
      className: _DeviceChartContainerModule.default.circular_progress
    }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
      sx: {
        color: "var(--main-color-cl-01)"
      }
    })) : null);
  }, [y1Data, y2Data, rangeType, dateType, setActive, isPrediction, inProgress, yScale.y1Scale, yScale.y2Scale, (_activeSelectors$y1Ax3 = activeSelectors.y1AxisSelect) === null || _activeSelectors$y1Ax3 === void 0 ? void 0 : _activeSelectors$y1Ax3.unit, (_activeSelectors$y2Ax3 = activeSelectors.y2AxisSelect) === null || _activeSelectors$y2Ax3 === void 0 ? void 0 : _activeSelectors$y2Ax3.unit]);
};
var _default = exports.default = MultiChart;